<template><section>
<h2 id="sample-zu-jian"><a class="header-anchor" href="#sample-zu-jian" aria-hidden="true">¶</a> sample组件</h2>
<h3 id="ji-chu-yong-fa"><a class="header-anchor" href="#ji-chu-yong-fa" aria-hidden="true">¶</a> 基础用法</h3>
<p>author设置为test</p>
<demo-block class="demo-box">
                            <div class="source" slot="source"><sample :author="author"></sample>
</div>
                            <p>样例代码</p>

                            <div class="highlight" slot="highlight"><pre><code class="hljs language-html"><span class="hljs-tag">&lt;<span class="hljs-name">sample</span> <span class="hljs-attr">:author</span>=<span class="hljs-string">"author"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">sample</span>&gt;</span>
</code></pre>
</div></demo-block>
<h3 id="api"><a class="header-anchor" href="#api" aria-hidden="true">¶</a> API</h3>
<table class="table"><thead>
<tr>
<th>参数</th>
<th>说明</th>
<th>类型</th>
<th>默认值</th>
<th>可选值</th>
</tr>
</thead>
<tbody>
<tr>
<td>className</td>
<td>自定义额外类名</td>
<td>string</td>
<td>''</td>
<td>''</td>
</tr>
</tbody>
</table>
</section></template>

<script>
export default {
  data() {
    return {
      author: 'pangxie'
    };
  }
};
</script>


// WEBPACK FOOTER //
// sample-2.vue?49b9e114